import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";

function TableHeader(columns) {
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (col) {
    return /*#__PURE__*/React.createElement("th", null, col.Header);
  })));
}

export function TableView(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      className = _ref.className,
      hasHeader = _ref.hasHeader;
  return /*#__PURE__*/React.createElement("table", {
    className: className
  }, hasHeader && TableHeader(columns), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row) {
    return /*#__PURE__*/React.createElement("tr", null, columns.map(function (col) {
      return /*#__PURE__*/React.createElement("td", null, row[col.Header]);
    }));
  })));
}
export var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = /*#__PURE__*/_createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.state = {
      tableData: []
    };
    return _this;
  }

  _createClass(Table, [{
    key: "parseCSVToJson",
    value: function parseCSVToJson(content) {
      var _this2 = this;

      import(
      /* webpackChunkName: "qtc-parsecsv" */
      "papaparse").then(function (_ref2) {
        var parse = _ref2.parse;
        parse(content, {
          header: _this2.props.hasHeader,
          complete: function complete(results) {
            return _this2._isMounted && _this2.setState({
              tableData: results.data
            });
          }
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.parseCSVToJson(this.props.data.content);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.data.content !== nextProps.data.content) {
        this.parseCSVToJson(nextProps.data.content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.state.tableData.length > 0) {
        return null;
      }

      var columns = Object.keys(this.state.tableData[0]).map(function (header) {
        return {
          Header: header,
          accessor: header,
          headerStyle: !_this3.props.hasHeader ? {
            display: "none"
          } : {}
        };
      });
      var className = "story-element-table-".concat(this.props.id);
      return /*#__PURE__*/React.createElement(this.props.tableComponent || TableView, {
        hasHeader: this.props.hasHeader,
        data: this.state.tableData,
        columns: columns,
        showPageSizeOptions: false,
        showPageJump: false,
        className: className
      });
    }
  }]);

  return Table;
}(React.Component);